import Color from 'color';
import {type Band} from 'uplot';

import {type RenderLine} from '../chartSeries';
import {type SeriesById, type SeriesEntry} from './getSeriesEntries';

/** Pair each min/max band's two edges and choose the fill color between them. */
export function getBands(
  seriesEntries: (SeriesEntry<RenderLine> | null)[],
  seriesById: SeriesById
): Band[] {
  const bands: Band[] = [];

  seriesEntries.forEach((entry, idx) => {
    if (entry == null) {
      return;
    }
    const seriesIdx = idx;

    if (entry.type === 'band-max') {
      const color = entry.line.color ?? 'red';
      const indices = seriesById.get(entry.line.seriesId);
      if (indices == null) {
        return;
      }
      const bandMinSeriesIndex = indices.bandMinSeriesIndex;
      if (bandMinSeriesIndex == null) {
        return;
      }

      bands.push({
        series: [seriesIdx, bandMinSeriesIndex],
        fill: Color(color).rgb().string(),
      });
    }
  });

  return bands;
}
